var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tongxin-layout"
  }, [_c('TongxinHeader'), _c('div', {
    staticClass: "tongxin-layout__content"
  }, [_vm.clinicIdData.isLoading ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _c('router-view', {
    key: _vm.$route.name
  })], 1), !_vm.isGuest ? _c('TermPopup') : _vm._e(), _c('ResultModal', {
    ref: "resultModal"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }